/** Nombre de la compañía con «TeamSystem» delante, salvo que ya lo lleve («TS Facturas»). */
export function conTeamSystem(nombre: string): string {
  return nombre.startsWith('TS ') ? nombre : `TeamSystem ${nombre}`;
}
